import type { TFunction } from 'i18next';

export const DISHES_SORT_ORDER = {
  NEWEST_FIRST: 'NEWEST_FIRST',
  OLDEST_FIRST: 'OLDEST_FIRST',
} as const;

export type DishesSortOrder =
  (typeof DISHES_SORT_ORDER)[keyof typeof DISHES_SORT_ORDER];

export type DishesSortOrderOption = {
  key: DishesSortOrder;
  value: string;
};

export const getDishesSortOrderOptions = (
  t: TFunction
): DishesSortOrderOption[] => [
  {
    key: DISHES_SORT_ORDER.NEWEST_FIRST,
    value: t('dishCategories.form.dishesSortOrder.newestFirst'),
  },
  {
    key: DISHES_SORT_ORDER.OLDEST_FIRST,
    value: t('dishCategories.form.dishesSortOrder.oldestFirst'),
  },
];
